<template>
  <div id="publishing-editorial-board-application">
    <div class='ipub-h1 mar-b-12'>
      Editorial Board Application
    </div>
    <ipub-row :gutter="[12, 16]">
      <ipub-col :span="2">
        <ipub-select v-model="params.journalId"
                     placeholder="Select Journal"
                     @change="changeJournal"
                     :options="journalList" />
      </ipub-col>
      <ipub-col :span="10">
        <site-search-group v-model.trim="params.keyword"
                           placeholder="Search by applier's name, email"
                           @search="getList()"
                           @clear="handleClear" />
      </ipub-col>
    </ipub-row>
    <div class="relative ipub-p1 line-h-40 mar-b-30">
      <div class="ipub-list-tab">
        <a @click="changeStatus('')"
           :class="['ipub-list-tab--status',params.handle===''?'active':'']">All Status</a>
        <a @click="changeStatus('UNHANDLED')"
           :class="['ipub-list-tab--status',params.handle==='UNHANDLED'?'active':'']">Pending</a>
        <a @click="changeStatus('ACCEPTED')"
           :class="['ipub-list-tab--status',params.handle==='ACCEPTED'?'active':'']">Accepted</a>
        <a @click="changeStatus('REFUSED')"
           :class="['ipub-list-tab--status',params.handle==='REFUSED'?'active':'']">Rejected</a>
      </div>

    </div>
    <div class="page-content">
      <ipub-table :columns="columns"
                  fixed
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:name="{record}">
          <ipub-tooltip style="width:100%"
                        placement="bottomLeft"
                        omis="omis"
                        :label="`${record.firstName} ${record.lastName}`" />
        </template>
        <template v-slot:roles="{text}">
          {{text?editorialBoard[text]||'- - ':'- -'}}
        </template>
        <template v-slot:operator="{text}">
          <ipub-tooltip v-if="text"
                        style="width:100%"
                        placement="bottomLeft"
                        omis="omis"
                        :label="`${text.firstName} ${text.lastName}`" />
          <template v-else>- -</template>
        </template>
        <template v-slot:status="{text}">
          <!-- <div v-if="text === 'REFUSED'"
               class="ipub-table-status-show"></div>
          <div v-else-if="text === 'ACCEPTED'"
               class="ipub-table-status-show ipub-table-status-show--active"></div>
          <div v-else-if="text === 'UNHANDLED'"
               class="ipub-table-status-show ipub-table-status-show--disable"></div> -->
          <ipub-label size="small"
                      type="success"
                      cover
                      style="width:80px"
                      v-if="text === 'ACCEPTED'">Accepted</ipub-label>
          <ipub-label size="small"
                      type="danger"
                      cover
                      style="width:80px"
                      v-else-if="text === 'REFUSED'">Refused</ipub-label>
          <ipub-label size="small"
                      type="default"
                      cover
                      style="width:80px"
                      v-else-if="text==='UNHANDLED'">Pending</ipub-label>
        </template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip class="border-right">
            <div slot="title">Details</div>
            <ipub-icon type="iconViewDetails"
                       @click="detail(record)" />
          </ipub-tooltip>
          <template v-if="record.handle === 'UNHANDLED'">
            <ipub-tooltip v-if="user.codeList&&user.codeList.includes('WEBSITE.EDITOR_BOARD.APPLY.ACCEPT')"
                          class="border-right">
              <div slot="title">Accept</div>
              <ipub-icon type="iconAble"
                         @click="accept(record, 'ACCEPTED')" />
            </ipub-tooltip>
            <ipub-tooltip v-if="user.codeList&&user.codeList.includes('WEBSITE.EDITOR_BOARD.APPLY.REFUSE')"
                          class="border-right">
              <div slot="title">Refuse</div>
              <ipub-icon type="iconDisable"
                         @click="accept(record, 'REFUSED')" />
            </ipub-tooltip>
          </template>
          <template v-else>
            <ipub-icon class="line-color"
                       type="iconAble" />
            <ipub-icon class="line-color"
                       type="iconDisable" />
          </template>
        </template>
      </ipub-table>
    </div>
    <Add ref="editorial-board-add"
         :isVisable="isVisable"
         :inputData="inputData"
         @confirm="confirm"
         @cancel="cancel" />
    <Detail :isVisable="isVisableDetail"
            :inputData="inputData"
            @cancel="cancel" />
    <SendEmail :isVisable="showSendEmail"
               :inputData="inputData"
               event="APPROVAL_OF_EDITORIAL_BOARD_MEMBER_APPLICATION"
               @send="send"
               @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
